export default {"src":"/_next/static/media/Star.4cfc4bf5.svg","height":25,"width":25};